export default __webpack_public_path__ + "static/media/txt_title5.e1a660d5.svg";